var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6 mt-4"},[_c('span',{class:_vm.label.classesDot}),_vm._v(" "),(_vm.label)?_c('span',{class:_vm.label.classesText},[_vm._v(_vm._s(_vm.label.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }